import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'src/react/components/buttons';
import Icon from 'src/react/components/icon/Icon';

const emptyTaskListProps = {
  onConfirm: PropTypes.func
};

const EmptyTaskList = (props) => {
  const { onConfirm } = props;

  return (
    <>
      <div
        data-testid="empty_tasklist"
        className="pt-3 sm:pt-12 items-start justify-center mb-6 sm:mb-12"
      >
        <Icon name="flame" className="mb-2" />
        <p className="text-gray-60 text-6">Nothing Added Yet</p>
        <Button
          className="w-full sm:w-auto"
          data-testid="tasklist_go_to_explore_button"
          size="large"
          onClick={() => onConfirm()}
        >
          Explore
        </Button>
      </div>
    </>
  );
};

EmptyTaskList.propTypes = { ...emptyTaskListProps };

export default EmptyTaskList;
